import axios from "axios";

//nst API_URL = "http://127.0.0.1:8000/";
const API_URL = "https://api.liendlhof.de/";

const getCSRFToken = async () => {
  const response = await fetch(`${API_URL}csrf/`, {
    credentials: "include",
  });
  const data = await response.json();
  return data.csrfToken;
};

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}token/`, { username, password });

    if (response.data.superuser) {
      localStorage.setItem("superuser", true);
      localStorage.setItem("superUserId", response.data.superuser);
    } else {
      localStorage.setItem("mieterId", response.data.mieter_id);
    }

    localStorage.setItem("token", response.data.access);
    localStorage.setItem("refreshToken", response.data.refresh);
    localStorage.setItem("username", response.data.username);

    return response.data;
  } catch (error) {
    console.error("Login failed:", error.response ? error.response.data : error.message);
    throw error;
  }
};

export const resetPassword = async (username) => {
  const csrfToken = await getCSRFToken();

  const response = await fetch(`${API_URL}${username}/resetpassword/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrfToken,
    },
    body: JSON.stringify({ username }),
    credentials: "include",
  });

  const data = await response.json();
  console.log(data);
  return data;
};

export const restPasswordConfirm = async (password, uid, token) => {
  try {
    const response = await axios.post(
      `${API_URL}confirm-password/`,
      {
        password: password,
        uid,
        token,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update password:", error);
    throw error;
  }
};

export const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const response = await axios.post(`${API_URL}token/refresh/`, { refresh: refreshToken });
    localStorage.setItem("token", response.data.access);
    return response.data.access;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    window.location.href = "/login";
  }
};

export const getZählerForMieter = async (mieterId) => {
  let token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${API_URL}mieter/${mieterId}/zaehler/`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      token = await refreshAccessToken();
      if (!token) return;
      const retryResponse = await axios.get(`${API_URL}mieter/${mieterId}/zaehler/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return retryResponse.data;
    }
    throw error;
  }
};

export const getZaehlerNummer = async (zaehlernummer) => {
  try {
    const response = await axios.get(`${API_URL}zaehler/${zaehlernummer}`);
    return response.data;
  } catch (error) {
    console.error("Fehler beim Laden der Zählerdaten:", error);
    throw error;
  }
};

export const getGroupsForSuperUser = async (token) => {
  try {
    const response = await axios.get(`${API_URL}users/grouped/`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Laden der Benutzer:", error);
  }
};

export const submitZaehlerstand = async (zaehlerId, date, reading) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${API_URL}zaehlerstand/`,
    { zaehler: zaehlerId, date, reading: parseFloat(reading) },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
};

export const updateZaehlerstand = async (entryId, date, reading, zaehlerId) => {
  const token = localStorage.getItem("token");

  const response = await axios.put(
    `${API_URL}zaehlerstand/${entryId}/`,
    {
      date,
      reading: parseFloat(reading),
      zaehler: zaehlerId,  // ✅ Add this line
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return response.data;
};


export const getMieterArray = async (token) => {
  try {
    const response = await axios.get(`${API_URL}mieter/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Laden der Mieter:", error);
    throw error;
  }
};

export const postPDFs = async (formData, token) => {
  try {
    const response = await axios.post(`${API_URL}documents/upload/`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Hochladen der PDF:", error);
    throw error;
  }
};

export const postNeuenMieter = async (formData, token) => {
  try {
    const response = await axios.post(`${API_URL}mieter/create/`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Erstellen des Mieters:", error);
    throw error;
  }
};

export const updateMieterCredentials = async (formData, token) => {
  const mieterId = localStorage.getItem("mieterId");

  try {
    const response = await axios.put(`${API_URL}mieter/${mieterId}/update/`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Aktualisieren der Mieter-Daten:", error);
    throw error;
  }
};

export const getMieter = async (mieterId, token) => {
  try {
    const response = await axios.get(`${API_URL}mieter/${mieterId}/`, {
      headers: { Authorization: `Bearer ${token}` } 
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Laden der Mieter-Credentials:", error);
    throw error;
  }
};


export const getPDFsForMieter = async (mieterId, token) =>{
  try {
    const response = await axios.get(`${API_URL}documents/${mieterId}/my-documents/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
     
    });
    return response.data
  } catch (error) {
    console.error("Fehler beim Laden der PDFs:", error);
    throw error;
  }
  
}

export const sendAdminEmail = async (payload, token) => {
  try {
    const response = await axios.post(`${API_URL}email/send/`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", // JSON for structured payload
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fehler beim Senden der E-Mail:", error);
    throw error;
  }
};

export const getFachfirmaList = async(token)=>{
  try {
    const response =await axios.get(`${API_URL}fachfirma/`, {
    headers: { Authorization: `Bearer ${token}` }
  });  
  return response.data;
} catch (error) {
  console.error("Fehler beim Senden der E-Mail:", error);
  throw error;
}
}

export const sendFachfirmaEmail= async(token, company, subject, message)=>{
  try {
    const response = await axios.post(`${API_URL}send-fachfirma-email/`, {
    email: company.email,
    subject,
    message,
  }, {
    headers: { Authorization: `Bearer ${token}` }
  });
return response.data;
} catch (error) {
console.error("Fehler beim Senden der E-Mail:", error);
throw error;
}
}